module.exports = __webpack_public_path__ + "img/mj8-aed.7ab74aeb.png";